export default (product, rawFilter) => {
    const filter = rawFilter?.length
        ? rawFilter.map((id) => +id)
        : [];

    return filter && filter.length
        ? !!~filter.indexOf(product.get('product')?.get('operator')?.id)
        : true;
};